/** O que a area de usuarios da empresa le do servidor. */
/** As duas abas. Vale como codigo de URL, entao nao muda sem pensar. */
export const COMPANY_USER_TABS = ['usuarios', 'solicitacoes'];
/**
 * As colunas das duas tabelas, na ordem da tela. Nenhuma ordena: a lista vem inteira e
 * na ordem do servidor. Moram aqui, e nao na view, porque o modelo da tabela precisa
 * delas para decidir a geometria; a view so desenha a celula de cada uma.
 */
export const USER_COLUMNS = [
    { field: 'nome', label: 'Nome' },
    { field: 'email', label: 'E-mail' },
    { field: 'cpf', label: 'CPF' },
    { field: 'papel', label: 'Papel' },
    { field: 'colaboradores', label: 'Colaboradores' },
    { field: 'acesso', label: 'Último acesso' },
    { field: 'acao', label: 'Ação' }
];
export const LINK_COLUMNS = [
    { field: 'nome', label: 'Nome' },
    { field: 'cpf', label: 'CPF' },
    { field: 'email', label: 'E-mail' },
    { field: 'solicitado', label: 'Solicitado em' },
    { field: 'acao', label: 'Ação' }
];
/** A de acoes so guarda botoes: largura de leitor nao faz sentido nela. */
export { ACTION_COLUMN } from '../../../../components/table';
//# sourceMappingURL=company-users.types.js.map